export default __webpack_public_path__ + "static/media/pending.97bf1c08.svg";